export type UtmSource = 'afiliado' | 'invitation' | 'afiliates';
export type UtmMedium = 'referral_link' | 'friend-plan';
export type UtmCampaign = 'financeads';

export interface Utm {
  campaign: string | UtmCampaign | null;
  content: string | null;
  medium: UtmMedium | null;
  source: UtmSource | null;
  term: string | null;
}

export const createEmptyUtm = (): Utm => ({
    campaign: null,
    content: null,
    medium: null,
    source: null,
    term: null
});
